export default hashids => (
  window.open(`${process.env.API_LOCATION}/delivery_notes/pdfs/download/?order_ids=${hashids.join(',')}&token=${localStorage.getItem('id_token')}`)
);



// WEBPACK FOOTER //
// ./src/app/services/invoice/bulkDownloadDeliveryNote.js